import React, { useCallback, useMemo } from 'react';
import parse from 'html-react-parser';
import { ProductAttributesFromCategories } from 'services/menu/menu.type';
import { TextStyle } from 'components/Text/TextStyle';
import {
    ItemContentContainer,
    ProductImage,
    StyledItemContainer,
    ItemTextContainer,
    ItemTitle,
    ItemDescription,
    StyledPrice,
    StyledUnavailableText,
} from './ProductItem.style';

export type ProductItemProps = ProductAttributesFromCategories & {
    currency: string;
    onClick?: (id: number) => void;
};

export const ProductItem: React.FunctionComponent<ProductItemProps> = ({
    name,
    price,
    description,
    image,
    currency,
    productId,
    onClick,
    currentQuantity,
}) => {
    const isDisabled = useMemo(() => currentQuantity === 0, [currentQuantity]);

    const handleOnProductClick = useCallback(() => {
        if (onClick && !isDisabled) onClick(productId);
    }, [productId, onClick, isDisabled]);

    return (
        <StyledItemContainer
            onClick={handleOnProductClick}
            isDisabled={isDisabled}
            data-testid="product-item"
        >
            <ItemContentContainer>
                <ItemTextContainer>
                    <ItemTitle text={name} noTranslation type={3} weight="Bold" />
                    <br />
                    {price > 0 && !isDisabled && (
                        <StyledPrice text={price} isCurrency currency={currency} type={3} />
                    )}
                    {isDisabled && (
                        <StyledUnavailableText
                            weight="Regular"
                            type={3}
                            text={'product_unavailable'}
                        />
                    )}
                    {description && !isDisabled && (
                        <ItemDescription>
                            <TextStyle type={3}>{parse(description)}</TextStyle>
                        </ItemDescription>
                    )}
                </ItemTextContainer>
                {image && (
                    <ProductImage
                        data-testid="product-image"
                        style={{ backgroundImage: `url("${image.fullUrl}")` }}
                    />
                )}
            </ItemContentContainer>
        </StyledItemContainer>
    );
};
